import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApNativeAppComponent, ApSignComponent } from '@ap/sign';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { ApIconComponent } from '@ap/icon';
import { ApNotificationComponent } from '@ap/notification';
import { ApIconButtonLinkComponent, ApIconLinkComponent } from '@ap/icon-link';
import { ApGridModule } from '@ap/grid';
import { ApKeywordExplanationComponent } from '@ap/explanation/keyword';

import { KantoorSignService } from './kantoor-sign.service';
import { KantoorSignComponent } from './kantoor-sign.component';

/**
 * @ngdoc module
 * @name KantoorSignModule
 */
@NgModule({
    providers: [KantoorSignService],
    declarations: [KantoorSignComponent],
    imports: [
        ApContentModule,
        ApIconComponent,
        ApNativeAppComponent,
        ApKeywordExplanationComponent,
        ApIconLinkComponent,
        ApSignComponent,
        SessiebeheerModule,
        ApNotificationComponent,
        CommonModule,
        ApGridModule,
        ApIconButtonLinkComponent
    ]
})
export class KantoorSignModule {}
